import { env } from "./environmentHelpers";

export const log: typeof console.log = (args) => {
  if (env.isDev) {
    console.log(args);
  }
};
